import React from "react";
import UploadedAttachmentList from "../UploadedAttachmentList";

const CustomTaskAttachmentSection = ({
  apiBase,
  attachmentTypes = [],
  selectedAttachmentType,
  onAttachmentTypeChange,
  pendingFiles,
  uploadedFiles,
  canEdit,
  isSaving,
  isReviewed,
  deletingFileId,
  onSelectFiles,
  onRemovePendingFile,
  onDeleteSavedAttachment,
  onSave,
  showSaveButton = true,
}) => (
  <div data-print-attachments-section>
    <hr className="my-4" />

    <h5>Attachments</h5>

    <form onSubmit={onSave}>
      {attachmentTypes.length > 0 && (
        <div className="mb-3">
          <label className="form-label">Attachment Type</label>
          <select
            className="form-control"
            value={selectedAttachmentType}
            disabled={!canEdit || isSaving}
            onChange={(event) => onAttachmentTypeChange(event.target.value)}
          >
            <option value="">Select an attachment type</option>
            {attachmentTypes.map((attachmentType) => (
              <option key={attachmentType} value={attachmentType}>
                {attachmentType}
              </option>
            ))}
          </select>
        </div>
      )}

      <div className="mb-3">
        <label>Select File</label>
        <input
          type="file"
          className="form-control"
          accept=".pdf,.jpg,.jpeg,.png,.msg"
          multiple
          disabled={
            !canEdit ||
            isSaving ||
            (attachmentTypes.length > 0 && !selectedAttachmentType)
          }
          onChange={onSelectFiles}
        />
      </div>

      {pendingFiles.length > 0 && (
        <div className="mt-4 p-3 bg-light rounded border">
          <div className="text-muted mb-2">Files Ready To Save</div>
          <ul className="list-unstyled mb-0">
            {pendingFiles.map((pendingEntry, index) => (
              <li
                key={`${pendingEntry.file.name}_${pendingEntry.file.size}_${pendingEntry.file.lastModified}_${pendingEntry.attachmentType}_${index}`}
                className="d-flex justify-content-between align-items-center py-1"
              >
                <span>
                  {pendingEntry.file.name}
                  {pendingEntry.attachmentType
                    ? ` - ${pendingEntry.attachmentType}`
                    : ""}
                </span>
                <button
                  type="button"
                  className="btn btn-sm btn-outline-danger"
                  onClick={() => onRemovePendingFile(pendingEntry)}
                  disabled={!canEdit || isSaving}
                  title="Delete"
                >
                  <i className="bi bi-trash"></i>
                </button>
              </li>
            ))}
          </ul>
        </div>
      )}
    </form>

    <UploadedAttachmentList
      title="Uploaded Files"
      files={uploadedFiles}
      getFileKey={(file) => file.ta_id}
      getFileName={(file) => file.ta_original_name}
      getFileMeta={(file) => file.ta_type || null}
      getFileViewUrl={(file) =>
        `${apiBase}/api/custom-tasks/attachment-file/${file.ta_id}?mode=view`
      }
      getFileDownloadUrl={(file) =>
        `${apiBase}/api/custom-tasks/attachment-file/${file.ta_id}?mode=download`
      }
      canDelete={canEdit}
      onDeleteFile={onDeleteSavedAttachment}
      deletingFileId={deletingFileId}
    />

    {isReviewed && (
      <div className="alert alert-info mt-3 mb-0">
        Attachments and task dates cannot be edited after review.
      </div>
    )}

    {showSaveButton && (
      <div className="d-flex justify-content-end mt-3">
        <button
          type="button"
          className="btn btn-primary"
          onClick={onSave}
          disabled={!canEdit || isSaving}
        >
          {isSaving ? "Saving..." : "Save"}
        </button>
      </div>
    )}
  </div>
);

export default CustomTaskAttachmentSection;
